import { Box, styled, Tab, Typography } from "@mui/material"

export const StyledTab = styled((props: any) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  //fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(14),
  marginLeft: theme.typography.pxToRem(26),
  paddingLeft: 0,
  color: "#707070",
  fontFamily: "Poppins, Medium",
  "&.Mui-selected": {
    color: "#000",
    fontWeight: "900",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#3C77EF",
  },
}))
